module.exports = __webpack_public_path__ + "img/404-error-dark.47e55d14.svg";